var map = {
	"./analysis-active.svg": 3428,
	"./analysis-report-active.svg": 4883,
	"./arroba-active.svg": 7460,
	"./edit-active.svg": 7119,
	"./email-active.svg": 1385,
	"./permission-active.svg": 8581,
	"./reply-active.svg": 4409,
	"./user-management-active.svg": 6969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5865;